<template>
    <div>
    <b-list-group-item :key="'itemsFiltered_' + index" :disabled="isItemDisabled(item)">
        <div class="row" :key="'custPayment_' + index">
            <div class="col-1">
                <b-form-checkbox :id="'cust-payment-check-' + item.id" :disabled="true" />
            </div>
            <div class="col">
                <h5>{{item.claimReference}}</h5>
                <div class="row">
                    <div class="col">
                        <small>{{item.underwriterName}} - {{item.resellerName}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col" v-if="item.relatedReference">
                        <small>{{item.relatedReference}} - Policy: {{item.policyNumber}}</small>
                    </div>
                    <div class="col" v-else>
                        <small>NO RELATED REFERENCE - Policy: {{item.policyNumber}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <small>Policy Cover Dates: {{localeString(item.policyCoverStartDate)}} - {{localeString(item.policyCoverEndDate)}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <small>Claimant: {{item.claimantTitle}} {{item.claimantFirstname}} {{item.claimantLastname}}</small>
                    </div>
                </div>
                <div v-if="item.children && item.children.length > 0">
                    <div v-for="(cld, cldIdx) in item.children">
                        <div class="row">
                            <div class="col">
                                <small>{{cld.gadgetMakeLabel}} - {{cld.gadgetModelLabel}}</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <small>IMEI / Serial: {{getIMEISerialNos(cld)}}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col">
                            <small>{{item.gadgetMakeLabel}} - {{item.gadgetModelLabel}}</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <small>IMEI / Serial: {{getIMEISerialNos(item)}}</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <small>Pipeline: <a href="#" @click="showPipelineResults(itm)">{{item.pipelineLabel}}</a> ({{item.pipelinePassed}}) <!--/ {{item.pipelineRunDate}})--></small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <small>Rate Type: {{item.policyRatingTypeName}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="font-weight-bold">Cover Limit: {{getCoverLimit(item)}}</span>
                        <i :id="'cover-limit-info-' + index" class="pointer pl-1 fas fa-info-circle" v-on:click.stop></i>
                        <b-popover :target="'cover-limit-info-' + index" triggers="hover focus">
                            <template #title>
                                Cover Limit(s)
                            </template>
                            <div class="row">
                                <div class="col">
                                    <small>Rate Type: {{item.policyRatingTypeName}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Device Value: {{item.gadgetValue}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>SAL: {{item.policySAL}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Cover Limit: {{item.policyCoverLimit}}</small>
                                </div>
                            </div>
                        </b-popover>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <small>Reimbursement Amount: ({{item.reimbursementCurrency}}) {{item.reimbursementAmount}} (Man)</small>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <small>VAT Registered: {{item.vatRegistered}}</small>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row mt-1">
                    <div class="col">
                        <b-list-group v-if="item.documentId">
                            <b-list-group-item href="javascript:void(0)" @click="openDocument(item)">
                                <div class="row">
                                    <div class="col">
                                        <i class="fas fa-file pr-1"></i> <small>{{item.documentOriginalFilename}}</small>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="col">
                                                <small>Status: {{item.documentStatusLabel}}</small> <i :id="'doc-status-info-' + index" class="pointer pl-1 fas fa-info-circle" v-on:click.stop></i>
                                            </div>
                                        </div>
                                        <div v-if="item.documentStatusCreatedByUser" class="row">
                                            <div class="col">
                                                <small>Approved by: {{item.documentStatusCreatedByUser}}</small>
                                            </div>
                                        </div>
                                        <b-popover :target="'doc-status-info-' + index" triggers="hover focus">
                                            <template #title>
                                                Document Status
                                            </template>
                                            <p><small><strong>APPROVED_APPROVAL_LIMIT_CHECK</strong> - Customer entered amount checked against Approval limits</small></p>
                                            <p><small><strong>APPROVED_AUTO_DOCUMENT_CHECK</strong> - Document values checked (OCR)</small></p>
                                            <p><small><strong>APPROVED_MANUAL</strong> - Claim agent approved manually</small></p>
                                        </b-popover>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <copy-to-clipboard :textToCopy="item.bankName">
                            <small>{{item.bankName}}</small>
                        </copy-to-clipboard>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <copy-to-clipboard :textToCopy="item.accountName"><small>{{item.accountName}}</small></copy-to-clipboard>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <copy-to-clipboard :textToCopy="item.accountNumber"><small>{{item.accountNumber}}</small></copy-to-clipboard>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <copy-to-clipboard :textToCopy="item.accountSortcode"><small>{{item.accountSortcode}}</small></copy-to-clipboard>
                    </div>
                </div>

                <div class="row">
                    <div class="col border-top mt-2">
                        <small>Claim Payment (net): ({{item.claimPaymentCurrencyCode}}) {{formatNumber(item.claimPaymentNet)}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <small>Claim Payment (tax): ({{item.claimPaymentCurrencyCode}}) {{formatNumber(item.claimPaymentTax)}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col ">
                        <small>Claim Payment (gross): ({{item.claimPaymentCurrencyCode}}) {{formatNumber(item.claimPaymentGross)}}</small>
                    </div>
                </div>
                <div class="row" v-if="item.claimPaymentAuthorisedBy">
                    <div class="col ">
                        <small>Authorised by: {{item.claimPaymentAuthorisedUser}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <small>Excess: ({{getExcessCurrencyCode(item)}}) {{formatNumber(getExcessAmount(item))}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <small>Excess waived: {{item.isExcessWaived}}</small>
                    </div>
                </div>
                <div class="col">
                    <div class="row pt-1" v-if="excessPaid(item)">
                        <small>Excess Payment: ({{item.cardPaymentCurrencyCode}}) {{formatNumber(item.cardPaymentAmount)}}</small> <i :id="'xs-payment-info-' + index" class="pointer pl-1 fas fa-info-circle"></i>
                        <b-popover :target="'xs-payment-info-' + index" triggers="hover focus">
                            <template #title>
                                Payment Details
                            </template>
                            <p><small>Payment Date: {{localeString(item.cardPaymentDate)}}</small></p>
                            <p><small>Transaction Id: {{item.cardPaymentTransactionId}}</small></p>
                        </b-popover>
                    </div>
                    <div v-else class="row pt-1">
                        <small>Excess Payment: (---) 0.00</small>
                    </div>
                </div>
                <div class="row ">
                    <div class="col">
                        <copy-to-clipboard :textToCopy="formatNumber(getPaymentAmount(item))">
                            <span class="text-small font-weight-bold">Amount to Pay: (GBP) {{formatNumber(getPaymentAmount(item))}}</span>
                        </copy-to-clipboard>
                    </div>
                </div>
            </div>
            <div class="col-1 border-left">
                <div class="row" style="height: 50%">
                    <div class="col">
                        <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                            <template #button-content>
                                <span>{{getStatusLabel(item)}} <i class="arrow down"></i></span>
                            </template>
                            <b-dropdown-item href="#" v-if="isResetEnabled(item)" :disabled="!isResetEnabled(item)" @click="setStatus(item,999)">RESET!</b-dropdown-item>
                            <b-dropdown-item href="#" :disabled="!isAuthorisedEnabled(item)" @click="setStatus(item,1000)">Authorised</b-dropdown-item>
                            <b-dropdown-item href="#" :disabled="!isRejectedEnabled(item)" @click="statusRejectedShow(item,1001)">Rejected</b-dropdown-item>
                            <b-dropdown-item href="#" :disabled="!isSchedulePaymentEnabled(item)" @click="statusSchedulePaymentShow(item,1003)">Scheduled</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item href="#" :disabled="!isPaidEnabled(item)" @click="statusPaidShow(item,1002)">Paid</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="row" style="height: 50%">
                    <div class="col align-self-end">
                        <span class="align-bottom"><button type="button" class="btn btn-outline-primary btn-sm" :disabled="!item.customerPaymentStatusId" @click="showTimelinePanel(item.id)"><i class="fa fa-clock"></i> Timeline</button></span>
                    </div>
                </div>
            </div>
        </div>
    </b-list-group-item>

        </div>
</template>
<script>
    import axios from 'axios'
    import CopyToClipboard from "@/components/CopyToClipboardV2.vue"
    export default {
        props: {
            index: Number,
            item: Object
        },
        components: {
            CopyToClipboard
        },
        data: () => {
            return {
                selectedItems: [],
                childWindows: {},
            }
        },
        beforeDestroy() {
            for (var prop in this.childWindows) {
                try {
                    this.childWindows[prop].close()
                } catch (err) { console.log(err) }
            }
        },
        methods: {
            localeString(val) {
                var dte = new Date(val)
                if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                    return dte.toLocaleString('en-GB', { timeZone: 'Europe/London' })

                return null
            },
            getExcessCurrencyCode(itm) {
                if (itm) {
                    if (itm.claimExcessCurrencyCode && itm.claimExcessCurrencyCode.length > 0 && itm.claimExcessAmount) {
                        return itm.claimExcessCurrencyCode
                    } else {
                        return itm.gadgetExcessCurrencyCode
                    }
                }
            },
            getExcessAmount(itm) {
                if (itm) {
                    if (itm.claimExcessCurrencyCode && itm.claimExcessCurrencyCode.length > 0 && itm.claimExcessAmount) {
                        return itm.claimExcessAmount
                    } else {
                        return itm.gadgetExcessAmount
                    }
                }
            },
            excessPaid(itm) {
                return itm.cardPaymentCurrencyCode && itm.cardPaymentAmount && itm.cardPaymentAmount > 0
            },
            getPaymentAmount(itm) {
                let amount = null
                let coverLimit = this.getCoverLimit(itm)

                if (itm.claimPaymentTypeId == 8) {
                    amount = itm.claimPaymentGross
                    return amount
                }
                else if (this.excessPaid(itm)) {
                    amount = itm.claimPaymentGross /*+ itm.cardPaymentAmount*/
                } else {
                    amount = itm.claimPaymentGross - this.getExcessAmount(itm)
                }

                if (coverLimit < amount)
                    return coverLimit

                return amount
            },
            getIMEISerialNos(itm) {
                if (itm) {
                    var imeiSerial = ''
                    if (itm.imeiNo && itm.imeiNo.length > 0) {
                        imeiSerial = itm.imeiNo
                    }
                    if (itm.serialNo && itm.serialNo.length > 0) {
                        if (imeiSerial.length > 0) {
                            imeiSerial += ' / '
                        }
                        imeiSerial += itm.serialNo
                    }
                    return imeiSerial
                }
                return ''
            },
            getCoverLimit(itm) {
                if (itm) {
                    if (itm.hasOwnProperty("policyRatingTypeId") &&
                        itm.hasOwnProperty("policySAL") &&
                        itm.hasOwnProperty("policyCoverLimit") &&
                        itm.hasOwnProperty("gadgetValue")) {
                        if (itm["policyRatingTypeId"] == 1) {
                            return itm["gadgetValue"]
                        } else if (itm["policyRatingTypeId"] == 2) {
                            return itm["policySAL"]
                        } else {
                            return itm["policyCoverLimit"]
                        }
                    }
                } else {
                    return null;
                }
            },
            formatNumber(val) {
                if (isNaN(val))
                    return 0.00

                return (Math.round(val * 100) / 100).toFixed(2)
            },
            getStatusLabel(itm) {
                //console.log('-i: ', itm)
                if (itm) {
                    if (itm.customerPaymentStatusLabel && itm.customerPaymentStatusLabel.length > 0) {
                        return itm.customerPaymentStatusLabel.split(' ')[0]
                    }
                }
                return 'Status'
            },
            isAuthorisedEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            isRejectedEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId && itm.customerPaymentStatusId == 1001) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            isPaidEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        if (itm.customerPaymentStatusId == 1003) {
                            return true
                        }
                    }
                }
                return false
            },
            isSchedulePaymentEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        if (itm.customerPaymentStatusId == 1000) {
                            return true
                        }
                    }
                }
                return false
            },
            isResetEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        if (itm.customerPaymentStatusId == 1001) {
                            return true
                        }
                    }
                }
                return false
            },
            isItemDisabled(itm) {
                if (itm && itm.customerPaymentStatusId == 1002) {
                    return true
                }
                return false
            },
            async openDocument(itm) {
                if (this.childWindows['document_' + itm.documentInternalFilename] == null ||
                    this.childWindows['document_' + itm.documentInternalFilename].closed) {

                    let response = await axios.get(window.location.origin + '/api/admin/v1/custpayments/key')

                    var url = window.location.origin + '/api/admin/v1/custpayments/download/' + itm.documentId + '/' + response.data
                    var filename = itm.documentOriginalFilename
                    var ext = filename.split('.').pop();

                    if (ext.toLowerCase() == 'pdf') {
                        this.childWindows['document_' + itm.documentInternalFilename] = window
                            .open(`/viewers/pdfViewer.html?url=${url}&filename=${filename}`, itm.claimReference, "width=500,height=700");
                    } else if (["jpg", "jpeg", "png"].indexOf(ext.toLowerCase()) >= 0) {
                        this.childWindows['document_' + itm.documentInternalFilename] = window
                            .open(`/viewers/imgViewer.html?url=${url}&filename=${filename}`, itm.claimReference, "width=500,height=700");
                    }
                } else {
                    this.childWindows['document_' + itm.documentInternalFilename].focus()
                }
            },
            statusSchedulePaymentShow(itm, statusId) {
                this.selectedItem = itm
                this.showSchedulePaymentModal = true
            },
            statusPaidShow(itm, statusId) {
                this.selectedItem = itm
                this.showPaidModal = true
            },
            statusRejectedShow(itm, statusId) {
                this.selectedItem = itm
                this.showRejectedModal = true
            },
            async statusPaidOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                //console.log('statusPaidOk: ', this.selectedItem)

                const payload = {
                    id: this.selectedItem.id,
                    statusId: 1002,
                    rv: this.selectedItem.rv,
                    sendPaymentEmail: this.sendPaymentEmail
                }

                var response = await this.setItemStatus(payload)
                //console.log('-r: ', response)
                this.showPaidModal = false

                this.paymentRef = null
                this.paymentNotes = null
                this.selectedItem = null
                this.sendPaymentEmail = true
            },
            async statusSchedulePaymentOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                //console.log('statusSchedulePaymentOk: ', this.selectedItem)

                const payload = {
                    id: this.selectedItem.id,
                    statusId: 1003,
                    rv: this.selectedItem.rv,
                    paymentRef: this.paymentRef,
                    paymentNotes: this.paymentNotes
                }

                var response = await this.setItemStatus(payload)
                //console.log('-r: ', response)
                this.showSchedulePaymentModal = false

                this.paymentRef = null
                this.paymentNotes = null
                this.selectedItem = null
            },
            statusPaidCancel(bvModalEvent) {
                console.log('statusPaidCancel: ', this.selectedItem)
                this.selectedItem = null
            },
            statusSchedulePaymentCancel(bvModalEvent) {
                //console.log('statusSchedulePaymentCancel: ', this.selectedItem)
                this.selectedItem = null
            },
            async statusRejectedOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                //console.log('statusRejectedOk: ', this.selectedItem)

                const payload = {
                    id: this.selectedItem.id,
                    statusId: 1001,
                    rv: this.selectedItem.rv,
                    rejectedReason: this.rejectedReason,
                    rejectedNotes: this.rejectedNotes
                }
                console.log('-p: ', payload)
                var response = await this.setItemStatus(payload)
                console.log('-r: ', response)
                this.showRejectedModal = false

                this.rejectedReason = null
                this.rejectedNotes = null
                this.selectedItem = null
            },
            statusRejectedCancel(bvModalEvent) {
                //console.log('statusRejectedCancel: ', this.selectedItem)
                this.selectedItem = null
            },
            setStatus(itm, statusId) {
                //console.log('itm: ', itm)
                this.$bvModal.msgBoxConfirm('Please confirm that you want to set the status')
                    .then(value => {
                        if (value === true) {
                            const payload = {
                                id: itm.id,
                                statusId,
                                rv: itm.rv
                            }

                            this.setItemStatus(payload)
                                .then(response => {

                                })
                                .catch(err => { /* DO NOTHING */ })
                                .finally(() => this.selectedItems = [])
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
        }
    }
</script>